import { render } from "./DocumentsLGPrice.vue?vue&type=template&id=6757159e&scoped=true"
import script from "./DocumentsLGPrice.vue?vue&type=script&lang=js"
export * from "./DocumentsLGPrice.vue?vue&type=script&lang=js"

import "./DocumentsLGPrice.vue?vue&type=style&index=0&id=6757159e&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6757159e"]])

export default __exports__